<details
  #menu
  class="ui-action-menu"
  [class.ui-action-menu-disabled]="disabled()"
>
  <summary
    class="ui-action-menu-trigger"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-disabled]="disabled() ? 'true' : null"
    (click)="handleSummaryClick($event)"
  >
    {{ triggerLabel() }}
  </summary>

  <div class="ui-action-menu-list" role="menu">
    @for (item of items(); track item.id) {
      <button
        class="ui-action-menu-item"
        type="button"
        role="menuitem"
        [class.ui-action-menu-item-danger]="item.tone === 'danger'"
        [disabled]="item.disabled === true"
        (click)="handleItemSelected(item, menu)"
      >
        {{ item.label }}
      </button>
    }
  </div>
</details>
